// extracted by mini-css-extract-plugin
export default {"avatar_wrap":"avatar_wrap_iDgkB","v":"v_bNGok"};